/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnumerationConditionSetupParameterAssignment } from './EnumerationConditionSetupParameterAssignment';
import {
    instanceOfEnumerationConditionSetupParameterAssignment,
    EnumerationConditionSetupParameterAssignmentFromJSON,
    EnumerationConditionSetupParameterAssignmentFromJSONTyped,
    EnumerationConditionSetupParameterAssignmentToJSON,
} from './EnumerationConditionSetupParameterAssignment';
import type { NumericConditionSetupParameterAssignment } from './NumericConditionSetupParameterAssignment';
import {
    instanceOfNumericConditionSetupParameterAssignment,
    NumericConditionSetupParameterAssignmentFromJSON,
    NumericConditionSetupParameterAssignmentFromJSONTyped,
    NumericConditionSetupParameterAssignmentToJSON,
} from './NumericConditionSetupParameterAssignment';
import type { TextConditionSetupParameterAssignment } from './TextConditionSetupParameterAssignment';
import {
    instanceOfTextConditionSetupParameterAssignment,
    TextConditionSetupParameterAssignmentFromJSON,
    TextConditionSetupParameterAssignmentFromJSONTyped,
    TextConditionSetupParameterAssignmentToJSON,
} from './TextConditionSetupParameterAssignment';

/**
 * @type IConditionValueAssignment
 * 
 * @export
 */
export type IConditionValueAssignment = { $type?: 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.EnumerationConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared' } & EnumerationConditionSetupParameterAssignment | { $type?: 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.NumericConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared' } & NumericConditionSetupParameterAssignment | { $type?: 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.TextConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared' } & TextConditionSetupParameterAssignment;


export function IConditionValueAssignmentFromJSON(json: any): IConditionValueAssignment {
    return IConditionValueAssignmentFromJSONTyped(json, false);
}

export function IConditionValueAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): IConditionValueAssignment {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.EnumerationConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared':
            return Object.assign({}, EnumerationConditionSetupParameterAssignmentFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.EnumerationConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.NumericConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared':
            return Object.assign({}, NumericConditionSetupParameterAssignmentFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.NumericConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.TextConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared':
            return Object.assign({}, TextConditionSetupParameterAssignmentFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.TextConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared' } as const);
        default:
            throw new Error(`No variant of IConditionValueAssignment exists with '$type=${json['$type']}'`);
    }
}

export function IConditionValueAssignmentToJSON(value?: IConditionValueAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.EnumerationConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared':
            return EnumerationConditionSetupParameterAssignmentToJSON(value);
        case 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.NumericConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared':
            return NumericConditionSetupParameterAssignmentToJSON(value);
        case 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.TextConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared':
            return TextConditionSetupParameterAssignmentToJSON(value);
        default:
            throw new Error(`No variant of IConditionValueAssignment exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the IConditionValueAssignment interface.
 */
export function instanceOfIConditionValueAssignment(value: any): value is IConditionValueAssignment {
    if (instanceOfEnumerationConditionSetupParameterAssignment(value)) return true;
    if (instanceOfNumericConditionSetupParameterAssignment(value)) return true;
    if (instanceOfTextConditionSetupParameterAssignment(value)) return true;
    return false;
}

